import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchLogoBlob } from '../api/customers';

// Fetches an org's logo as a blob (auth header via the axios interceptor,
// since a plain <img src> can't carry it) and exposes it as an object URL
// for use directly in an <img src>. Revokes the previous object URL on
// change/unmount to avoid leaking memory.
export function useLogoUrl(orgId: string | null | undefined, hasLogo: boolean | undefined): string | null {
  const { data: blob } = useQuery({
    queryKey: ['logo', orgId],
    queryFn: () => fetchLogoBlob(orgId!),
    enabled: !!orgId && !!hasLogo,
    staleTime: 5 * 60_000,
  });

  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!blob) {
      setUrl(null);
      return;
    }
    const objectUrl = URL.createObjectURL(blob);
    setUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [blob]);

  return url;
}
